const getLocales = () => {
  return [
    {
      languageCode: "en",
    },
    { languageCode: "ar" },
  ];
};

export { getLocales };
